import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Projects from './views/Projects.vue'
import ProjectDetail from './views/ProjectDetail.vue'
import ProjectNew from './views/ProjectNew.vue'
import Stats from './views/Stats.vue'
import Admin from './views/Admin.vue'
import Users from './views/Users.vue'
import UserDetail from './views/UserDetail.vue'
Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Projects
    },
    {
      path: '/project/new',
      name: 'projectNew',
      component: ProjectNew
    },
    {
      path: '/project/:id',
      name: 'project',
      component: ProjectDetail
    },
    {
      path: '/stats',
      name: 'stats',
      component: Stats
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/user/:userId',
      name: 'userDetail',
      component: UserDetail
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
